import React from "react";



const UserContext = React.createContext({userId: 0, scheduleId: 0, username: 'Guest'});


export default UserContext;